import {
	PROJECT_AREA,
	PROJECT_ACTION,
	TICKET_ACCESS_LEVEL,
} from "../../constant/projectPermissions";
/**
 * Maps a project detail pathname to the permission check for that area.
 */
export function getProjectRouteAccess(pathname, projectId, permission) {
	const {
		can,
		ticketViewLevel,
		ticketCategoryIds,
		isLocalProject,
	} = permission;

	if (!pathname.includes(`/projects/${projectId}`)) {
		return true;
	}

	const relative = pathname.split(`/projects/${projectId}`)[1] || "";
	const segment = relative.replace(/^\//, "").split("/")[0] || "";

	if (!segment || segment === "") {
		return can(PROJECT_AREA.OVERVIEW, PROJECT_ACTION.VIEW);
	}

	if (segment === "planning") return can(PROJECT_AREA.PLANNING, PROJECT_ACTION.VIEW);
	if (segment === "cost-tracking") return can(PROJECT_AREA.COST_TRACKING, PROJECT_ACTION.VIEW);
	if (segment === "ticket-categories") {
		return (
			can(PROJECT_AREA.TICKET_CATEGORIES, PROJECT_ACTION.VIEW) &&
			!(Array.isArray(ticketCategoryIds) && ticketCategoryIds.length === 0)
		);
	}
	if (segment === "lv") return can(PROJECT_AREA.LV, PROJECT_ACTION.VIEW);
	if (segment === "invoice" || segment === "invoice-v2") {
		return can(PROJECT_AREA.INVOICE, PROJECT_ACTION.VIEW);
	}
	if (segment === "tickets") {
		return isLocalProject && ticketViewLevel !== TICKET_ACCESS_LEVEL.NONE;
	}
	if (segment === "members" || segment === "permission-presets") {
		return can(PROJECT_AREA.MEMBERS, PROJECT_ACTION.VIEW);
	}
	if (segment === "companies") return can(PROJECT_AREA.COMPANIES, PROJECT_ACTION.VIEW);

	return true;
}

export function getNavTabVisibility(itemId, permission) {
	const {
		can,
		ticketViewLevel,
		ticketCategoryIds,
		isLocalProject,
	} = permission;

	switch (itemId) {
		case "overview":
			return can(PROJECT_AREA.OVERVIEW, PROJECT_ACTION.VIEW);
		case "planning":
			return can(PROJECT_AREA.PLANNING, PROJECT_ACTION.VIEW);
		case "cost-tracking":
			return can(PROJECT_AREA.COST_TRACKING, PROJECT_ACTION.VIEW);
		case "ticket-categories":
			return (
				can(PROJECT_AREA.TICKET_CATEGORIES, PROJECT_ACTION.VIEW) &&
				!(Array.isArray(ticketCategoryIds) && ticketCategoryIds.length === 0)
			);
		case "lv":
			return can(PROJECT_AREA.LV, PROJECT_ACTION.VIEW);
		case "invoice":
			return can(PROJECT_AREA.INVOICE, PROJECT_ACTION.VIEW);
		case "tickets":
			return isLocalProject && ticketViewLevel !== TICKET_ACCESS_LEVEL.NONE;
		case "members":
		case "permission-presets":
			return can(PROJECT_AREA.MEMBERS, PROJECT_ACTION.VIEW);
		case "companies":
			return can(PROJECT_AREA.COMPANIES, PROJECT_ACTION.VIEW);
		default:
			return true;
	}
}
